import { IonButton, IonCard, IonCardContent, IonCol, IonIcon, IonRow, IonSpinner, IonText } from "@ionic/react";
import { cardOutline, chevronBackOutline, chevronForwardOutline } from "ionicons/icons";
import { useState } from "react";
import './NavButtons.css'

interface Props {
    slider: any,
    maxStep: number,
    finalHas?: boolean,
    finalLoading?: boolean,
    finalText?: string,
    finalIcon?: string,
    nextClick: any,
    doneClick?: any,
    finalClick?: any
    finalDisabled?: boolean
}

const NavButtons: React.FC<Props> = (props) => {
    const [currentStep, setCurrentStep] = useState(0);

    const prevClickHandler = () => {
        var step = currentStep;

        if (step > 0) {
            step -= 1;
            setCurrentStep(step);
        }

        props.slider?.slideTo(step)
    }

    const nextClickHandler = () => {
        var step = currentStep;

        if (!props.nextClick(step)) {
            return;
        }

        if (step < props.maxStep) {
            step += 1;
            setCurrentStep(step);
        } else {
            props.doneClick();
        }

        props.slider?.slideTo(step)
    }

    return <IonCard className="nav-button">
        <IonCardContent>
            <IonRow>
                <IonCol size="6" className="ion-no-padding">
                    {currentStep == 0 ?
                        <IonButton expand="block" className="prev-button" disabled>
                            <IonIcon src={chevronForwardOutline}/>
                            <IonText>مرحله قبل</IonText>
                        </IonButton>
                        :
                        <IonButton onClick={prevClickHandler} expand="block" className="prev-button">
                            <IonIcon src={chevronForwardOutline}/>
                            <IonText>مرحله قبل</IonText>
                        </IonButton>}
                </IonCol>

                <IonCol size="6" className="ion-no-padding">
                    {currentStep == props.maxStep ?
                        (!props.finalHas ?
                            <IonButton expand="block" className="next-button" disabled>
                                <IonIcon src={chevronBackOutline}/>
                                <IonText>مرحله بعد</IonText>
                            </IonButton>
                            :
                            <IonButton onClick={props.finalClick} expand="block" className="final-button" disabled={props.finalDisabled}>
                                {props.finalLoading ?
                                    <IonSpinner />
                                    :
                                    <>
                                        <IonIcon src={props.finalIcon}/>
                                        <IonText>{props.finalText}</IonText>
                                    </>}
                            </IonButton>)
                        :
                        <IonButton onClick={nextClickHandler} expand="block" className="next-button">
                            <IonIcon src={chevronBackOutline}/>
                            <IonText>مرحله بعد</IonText>
                        </IonButton>
                    }
                </IonCol>
            </IonRow>
        </IonCardContent>
    </IonCard>;
}

export default NavButtons